export const BtnWspBubble = () => {
  return (
    <svg
      className="custom__wsp__button"
      viewBox="0 0 99 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_513_237)">
        <path
          d="M2.11749 49.4016C2.11516 57.8035 4.31051 66.0074 8.48493 73.2384L1.71826 97.9446L27.002 91.3151C33.9951 95.1221 41.8304 97.117 49.7927 97.1175H49.8136C76.0985 97.1175 97.495 75.7287 97.5062 49.4392C97.5113 36.7 92.5547 24.7209 83.5493 15.7085C74.5454 6.6969 62.5706 1.7314 49.8117 1.72559C23.5237 1.72559 2.12873 23.1132 2.11787 49.4016"
          fill="url(#paint0_linear_513_237)"
        />
        <path
          d="M0.414729 49.386C0.412016 58.0903 2.68605 66.5876 7.0093 74.0775L0 99.6694L26.1903 92.8023C33.4066 96.7368 41.5314 98.8112 49.7988 98.8143H49.8202C77.0481 98.8143 99.2132 76.6562 99.2248 49.4256C99.2295 36.2287 94.0946 23.819 84.7674 14.4837C75.4391 5.14961 63.036 0.00542636 49.8202 0C22.5876 0 0.425581 22.155 0.414729 49.386ZM16.012 72.7876L15.0341 71.2353C10.9233 64.6988 8.75349 57.1454 8.75659 49.3891C8.76512 26.7554 27.1853 8.34109 49.8357 8.34109C60.8047 8.34574 71.1132 12.6217 78.8667 20.3798C86.6198 28.1388 90.886 38.4527 90.8833 49.4225C90.8733 72.0562 72.4527 90.4729 49.8202 90.4729H49.8039C42.4345 90.469 35.207 88.4899 28.9039 84.75L27.4039 83.8605L11.862 87.9353L16.012 72.7876Z"
          fill="url(#paint1_linear_513_237)"
        />
        <path
          d="M37.4721 28.7393C36.5473 26.6839 35.5741 26.6424 34.6946 26.6064C33.9744 26.5753 33.1512 26.5777 32.3287 26.5777C31.5055 26.5777 30.1679 26.8874 29.0372 28.1219C27.9055 29.3575 24.7163 32.3436 24.7163 38.4168C24.7163 44.4905 29.14 50.3598 29.7566 51.1843C30.3741 52.0071 38.2965 64.8691 50.8438 69.8172C61.2717 73.9292 63.3938 73.1114 65.657 72.9052C67.9206 72.6998 72.9609 69.9199 73.9892 67.0374C75.0182 64.1552 75.0182 61.6847 74.7097 61.1684C74.4012 60.654 73.5779 60.3451 72.3434 59.7281C71.1086 59.1106 65.0396 56.1242 63.9082 55.7122C62.7764 55.3005 61.9535 55.0951 61.1303 56.3312C60.307 57.5653 57.9431 60.3451 57.2225 61.1684C56.5027 61.9936 55.7822 62.0963 54.5481 61.4788C53.3128 60.8595 49.3372 59.5575 44.6206 55.3525C40.9508 52.0804 38.4733 48.0397 37.7531 46.8036C37.033 45.5695 37.676 44.9005 38.295 44.2854C38.8496 43.7323 39.5299 42.844 40.1477 42.1234C40.7632 41.4025 40.9686 40.8881 41.3803 40.0649C41.7923 39.2409 41.5861 38.5199 41.2779 37.9025C40.9686 37.285 38.5698 31.18 37.4721 28.7393Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_513_237"
          x1="4791.12"
          y1="9623.63"
          x2="4791.12"
          y2="1.72559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FAF38" />
          <stop offset="1" stop-color="#60D669" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_513_237"
          x1="4961.24"
          y1="9966.94"
          x2="4961.24"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F9F9F9" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_513_237">
          <rect width="99.2248" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
